module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch3"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch3.jpg",
      "width": "8%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("I opened my mouth to scream, but only a squeak came out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I heard people laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The big claws slid off my waist. Plastic claws.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I saw two dark eyes staring out at me from behind the wolf mask. I should have known that it was a man in a costume. But I didn’t expect him to be standing there.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I was surprised, that’s all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I blinked at a white flash of light. A man had just taken a picture of the creature. I saw a big red and yellow sign against the wall: "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("SEE THE MOVIE — THEN PLAY THE GAME ONLINE")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sorry if I scared you,” the man inside the wolf-crab costume said softly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She scares easily!” Marty declared.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I gave Marty a hard shove, and we hurried away. I turned back to see the creature waving a claw at me. “We’ve got to go upstairs and see my dad,” I told Marty.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Tell me something I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("don’t")]), _vm._v(" know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He thinks he’s so funny.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dad’s office is upstairs from the theater, on the twenty-ninth floor. We jogged to the elevators at the end of the hall and took one up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dad has a really cool job. He builds theme parks. And he designs all kinds of rides.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dad was one of the designers of Prehistoric Park. That’s the big theme park where you go back to prehistoric times. It has all kinds of neat rides and shows — and dozens of huge dinosaur robots wandering around.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And Dad worked on the Fantasy Films Studio Tour. Everyone who comes to Hollywood goes on that tour.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dad’s idea was the part where you walk through a huge movie screen and find yourself in a world of movie characters. You can star in any kind of movie you want to be in!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I know it sounds as if I’m bragging, but Dad is really smart, and he’s an engineering genius! I think he is the world expert on robots. He can build robots that will do anything! And he uses them in all his parks and studio tours.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Marty and I stepped off the elevator on the twenty-ninth floor. We waved to the woman at the front desk. Then we hurried to Dad’s office at the end of the hall.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It looks more like a playroom than an office. It’s a big room. Huge, really. Filled with toys, and stuffed cartoon characters, movie posters, and models of monsters.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Marty and I love to roam around the office, staring at all the neat stuff. On the walls, Dad has great posters from a dozen different movies. On a long table, he has a model of The Tumbler, the upside-down roller coaster he designed. The model has little cars that really screech around the tracks.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And he has a lot of cool stuff from Shock Street — like one of the original furry paws that Wolf Girl wore in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nightmare on Shock Street")]), _vm._v(". He keeps it in a glass case on the windowsill.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He has models of tramcars and little trains and planes and rockets. Even a big silver plastic blimp. It’s radio-controlled, and he can make it float around and around his office.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What a great place! I always think of Dad’s office as the happiest place in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But today, as Marty and I stepped inside, Dad didn’t look too happy. He hunched over his desk with the telephone to his ear. His head was lowered, his eyes down. He kept a hand pressed against his forehead as he mumbled into the phone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dad and I don’t look at all alike. I’m short and dark. He’s tall and thin. And he has blond hair, although there’s not much left of it. He’s pretty bald.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He has the kind of skin that turns red easily. His cheeks get real pink when he talks. And he wears big, round glasses with dark frames that hide his brown eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Marty and I stopped at the doorway. I don’t think Dad saw us. He stared down at the desk. He had his tie pulled down and his shirt collar open.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He muttered for a short while longer. Marty and I crept into the office.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Finally, Dad set down the phone. He raised his eyes and saw us. “Oh, hi, you two,” he said softly. His cheeks turned bright pink.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dad — what’s wrong?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He sighed. Then he pulled off his glasses and pinched the bridge of his nose. “I have very bad news, Erin. Very bad news.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-524ea4f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545820585_ch003.vue
// module id = 69
// module chunks = 0